import axios from "axios";
import { getApiBaseUrl } from "./site-profile";
import { getMeetupMapFallback } from "./meetup-map-fallback";

function isValidPinPayload(data) {
  return data && Array.isArray(data.pins);
}

/**
 * Load map pins — API first, then embedded WGS84 fallback (static Pages deploy).
 */
export async function fetchMeetupMapPins({ country, parish, category } = {}) {
  const params = {};
  if (country) params.country = country;
  if (parish) params.parish = parish;
  if (category) params.category = category;

  const bases = [
    getApiBaseUrl(),
    process.env.REACT_APP_BACKEND_URL
      ? `${String(process.env.REACT_APP_BACKEND_URL).replace(/\/$/, "")}/api`
      : null,
  ].filter(Boolean);

  const seen = new Set();
  for (const base of bases) {
    if (seen.has(base)) continue;
    seen.add(base);
    try {
      const res = await axios.get(`${base}/meetups/map-pins`, {
        params,
        withCredentials: true,
        timeout: 12000,
      });
      if (isValidPinPayload(res.data) && res.data.pins.length > 0) {
        return { ...res.data, source: "api" };
      }
    } catch (_err) {
      // try next origin or fallback
    }
  }

  return getMeetupMapFallback({ country, parish, category });
}
